import $ from 'jquery'; //eslint-disable-line import/no-unresolved, import/extensions, import/no-extraneous-dependencies
import user from 'btm-user-manager'; //eslint-disable-line import/no-extraneous-dependencies
import disneyOneIdWrapper from 'disneyOneIdWrapper'; //eslint-disable-line import/no-unresolved, import/extensions
import * as bamDeepGet from 'bam-deep-get';
import getScrollPositionAndToggleStickyHeader from '../scripts/sticky-header';
import getScrollPositionToMoveChevron from '../scripts/hero-chevron-scroll';
import {
    getActiveSubscriptions,
    mapSubscriptionData,
    _containsElement
} from './dictionary-select-helper';
import trackPage from './tracking-suite/tracking-entry';
import { addClickHandlerToButtons } from './click-handler';

const $spinnerLoader = $('#spinner-loader');
const $unentitledView = $('#mlp-unentitled-view');
const $entitledView = $('#mlp-entitled-view');
const $entitledMonthlyView = $('#mlp-entitled-monthly-view');
const $subscribePlaceholder = $('#mlp-page-placeholder');
const visiblePageClass = 'page-content-visible';

function toggleVisible($el) {
    $el.addClass(visiblePageClass);
}

function resetPlaceholderHeight() {
    $subscribePlaceholder.css('height', 'auto');
}

function removeSpinner() {
    $spinnerLoader.removeClass('loading');
}

function getPageBasedOnEntitlements(subscriptions) {

    console.log('Got entitlements: ', subscriptions);

    // Case: only one page to show
    if ($('#mlp-page-placeholder .page-content').length === 1) {
        return $unentitledView;
    }

    // Is the user entitled?
    if (subscriptions &&
        subscriptions.entitlements &&
        subscriptions.entitlements.length) {
        const isEntitled = _containsElement('ESPN_PLUS', subscriptions.entitlements);
        if (isEntitled) {
            /* Do we have a monthly-specific view,
             and does the user have the category code that means they're upgradable?
              IE. The user is non-IAP and a monthly user.
            */
            if ($entitledMonthlyView.length &&
                subscriptions.categoryCodes.indexOf('espn_switch_from') !== -1) {
                return $entitledMonthlyView;
            } else {
                return $entitledView;
            }
        }
    }

    // Otherwise show unentitled view
    return $unentitledView;
}


function showPage(selectedPage) {
    toggleVisible(selectedPage);
    trackPage();
    addClickHandlerToButtons();
    removeSpinner();
    getScrollPositionAndToggleStickyHeader(true);
    getScrollPositionToMoveChevron(true);
    resetPlaceholderHeight();
}

const getSubscriptionEntitlementsPromise = disneyOneIdWrapper.init()
    .then((data) => {
        const token = bamDeepGet.deepGet(data, 'guest.token.id_token', '');
        const swid = bamDeepGet.deepGet(data, 'guest.profile.swid', '');
        return user.external.syncExternalToBtm(data.loggedIn, token, swid).then(() => {
            return getActiveSubscriptions(swid);
        });
    });

if (window.btmhasEntitledView) {
    getSubscriptionEntitlementsPromise
        .then(mapSubscriptionData)
        .then(getPageBasedOnEntitlements)
        .then((pageToShow) => {
            showPage(pageToShow);
        }).catch((e) => {
            console.error('Error getting subscription info: ', e);
            showPage($unentitledView);
        });
} else {
    showPage($unentitledView);
}

export {
    getPageBasedOnEntitlements,
    $unentitledView,
    $entitledMonthlyView,
    $entitledView
};
